import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const listGiftCard = catchAsync(async (locationId) => {
  const { data } = await axiosInstance.get(`salon/${locationId}/gift-cards`);
  return data;
});
export const getGiftCardDetails = catchAsync(async (locationId, giftCardId) => {
  const { data } = await axiosInstance.get(
    `salon/${locationId}/gift-cards/${giftCardId}`
  );
  return data;
});

export const addGiftCard = catchAsync(async (locationId, body) => {
  const data = await axiosInstance.post(`salon/${locationId}/gift-cards`, body);
  return data;
});
export const updateGiftCard = catchAsync(
  async (locationId, giftCardId, body) => {
    const data = await axiosInstance.put(
      `salon/${locationId}/gift-cards/${giftCardId}`,
      body
    );
    return data;
  }
);

export const deleteGiftCard = catchAsync(async (locationId, giftCardId) => {
  const { data } = await axiosInstance.delete(
    `salon/${locationId}/gift-cards/${giftCardId}`
  );
  return data;
});
